export default __webpack_public_path__ + "1e96c4212e7e13b246124195c56160d3.svg";